import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Nav from "./components/Nav";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Strategies from "./pages/Strategies";
import CreateStrategy from "./pages/CreateStrategy";
import EditStrategy from "./pages/EditStrategy";
import StrategyDetail from "./pages/StrategyDetail";
import Leaderboard from "./pages/Leaderboard";
import PlayerPassPage from "./pages/PlayerPassPage";
import Forum from "./pages/Forum";
import ForumPostDetail from "./pages/ForumPostDetail";
import CreateForumPost from "./pages/CreateForumPost";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 font-hand text-3xl">loading…</div>;
  return user ? <Navigate to="/home" replace /> : <Landing />;
}

function Footer() {
  return (
    <footer className="bg-ink text-cream mt-16 border-t-4 border-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <div className="font-display font-extrabold text-3xl uppercase tracking-tight">
            <span className="text-marker-red">#</span>NoJobNoVC
          </div>
          <p className="mt-2 text-sm text-cream/70 leading-relaxed">
            A digital home where dreams are funded by grit, not privilege.
          </p>
        </div>
        
        <div className="text-sm">
          <div className="font-mono uppercase tracking-widest text-cream/60 mb-3">Players</div>
          <ul className="space-y-2 text-cream/80">
            <li>100+ active</li>
            <li>3 continents</li>
            <li>0 VCs</li>
          </ul>
        </div>
        
        <div className="text-sm">
          <div className="font-mono uppercase tracking-widest text-cream/60 mb-3">The rules</div>
          <ul className="space-y-2 text-cream/80">
            <li>1. No outside capital.</li>
            <li>2. Build in public.</li>
            <li>3. Lift the village.</li>
          </ul>
        </div>

        <div className="text-sm">
          <div className="font-mono uppercase tracking-widest text-cream/60 mb-3">Contact</div>
          <p className="text-cream/80 leading-relaxed">
            For any queries, community enhancements, or promotions, reach out at:
          </p>
          <a href="mailto:rahulsrivatsav@nojobnovc.com" className="inline-block mt-2 font-mono text-marker-red hover:underline break-all">
            rahulsrivatsav@nojobnovc.com
          </a>
        </div>
      </div>
      <div className="border-t border-cream/20 py-4 text-center font-mono text-xs uppercase tracking-widest text-cream/60">
        Built by players · est. 2026
      </div>
    </footer>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Nav />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/me" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/u/:id" element={<Profile />} />
            <Route path="/strategies" element={<Strategies />} />
            <Route path="/strategies/new" element={<ProtectedRoute><CreateStrategy /></ProtectedRoute>} />
            <Route path="/s/:id/edit" element={<ProtectedRoute><EditStrategy /></ProtectedRoute>} />
            <Route path="/s/:id" element={<StrategyDetail />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/forum/new" element={<ProtectedRoute><CreateForumPost /></ProtectedRoute>} />
            <Route path="/forum/:id" element={<ForumPostDetail />} />
            <Route path="/pass" element={<ProtectedRoute><PlayerPassPage /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
